export const selectOfferReportsFilters = (state) =>
  state?.offersReports?.filters;

export const selectOfferReportsFilterValues = (state) =>
  state?.offersReports?.filterWithvalues;

export const selectOfferReportsTimeFrame = (state) =>
  state?.offersReports?.time;
export const selectOfferReportsGroup = (state) => state?.offersReports?.group;

export const selectOfferCard = (state) => state?.offersReports?.cards;
export const selectOfferCardIsLoading = (state) =>
  state?.offersReports?.isCardLoading;

export const selectOfferByDepartment = (state) =>
  state?.offersReports?.hiresByDepartment;
export const selectOfferByDepartmentLoading = (state) =>
  state?.offersReports?.isHiresByDepartmentLoading;

export const selectOfferBySource = (state) =>
  state?.offersReports?.hiresBySource;
export const selectOfferBySourceLoading = (state) =>
  state?.offersReports?.isHiresBySourceLoading;

export const selectOfferRejectedReason = (state) =>
  state?.offersReports?.offerRejectionByReason;
export const selectOfferRejectedReasonisLoading = (state) =>
  state?.offersReports?.isOfferRejectionByReasonLoading;

export const selectOfferChart = (state) => state?.offersReports?.chart;
export const selectOfferTable = (state) => state?.offersReports?.table;
export const selectOfferChartLoading = (state) =>
  state?.offersReports?.isChartLoading;
export const selectOfferTableLoading = (state) =>
  state?.offersReports?.isTableLoading;
